import styles from './SeparadorChico.module.css'


export default function SeparadorChico (){
  return <div className={styles.Separador}></div>
}